<template>
  <div class="container">
    <section>
      <div class="home-bg">
        <img src="@/assets/image/home/bg.png" alt="" />
        <div class="bg-text">
          <span data-aos="fade-up" data-aos-duration="1000" class="home-title" style="color: #026efe">{{
            $t("home.title")
          }}</span>
          <span data-aos="fade-up" data-aos-duration="1100" class="home-title">{{ $t("home.subtitle") }}</span>
          <span data-aos="fade-up" data-aos-duration="1200" class="home-sub-title">{{ $t("home.threetitle") }}</span>
          <div data-aos="fade-up" data-aos-duration="1300" class="home-btn">
            <button @click="goHref">{{ $t("home.homeBtn") }}</button>
            <button @click="goHref">{{ $t("home.tryBtn") }}</button>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div data-aos="fade-up" class="fenlei-box">
        <div class="fenlei-box-tl">
          <span>{{ $t("home.title2") }}</span>
          <span>{{ $t("home.subtitle2") }}</span>
        </div>
        <div class="home-change">
          <img src="@/assets/image/home/homeChange.png" alt="" />
        </div>
        <div class="fenlei-btn">
          <img src="@/assets/image/home/icon-tl.png" alt="" />
          <span>{{ $t("home.homeBtn2") }}</span>
        </div>
        <div class="fenlei-line"></div>
        <div class="fenlei-top">
          <div class="fenlei-item">
            <img class="fenlei-img" src="@/assets/image/home/Face.png" alt="" />
          </div>
          <div class="fenlei-item">
            <img class="fenlei-img" src="@/assets/image/home/Messenger.png" alt="" />
          </div>
          <div class="fenlei-item">
            <img class="fenlei-img" src="@/assets/image/home/Ins.png" alt="" />
          </div>
          <div class="fenlei-item">
            <img class="fenlei-img" src="@/assets/image/home/WhatsApp.png" alt="" />
          </div>
          <div class="fenlei-item">
            <img class="fenlei-img" src="@/assets/image/home/TikTok.png" alt="" />
          </div>
          <div class="fenlei-item">
            <img class="fenlei-img" src="@/assets/image/home/Telegram.png" alt="" />
          </div>
          <div class="fenlei-item">
            <img class="fenlei-img" src="@/assets/image/home/Email.png" alt="" />
          </div>
          <div class="fenlei-item">
            <img class="fenlei-img" src="@/assets/image/home/Line.png" alt="" />
          </div>
          <div class="fenlei-item">
            <img class="fenlei-img" src="@/assets/image/home/Live.png" alt="" />
          </div>
          <div class="fenlei-item">
            <img class="fenlei-img" src="@/assets/image/home/VKontakte.png" alt="" />
          </div>
          <div class="fenlei-item">
            <img class="fenlei-img" src="@/assets/image/home/WeChat.png" alt="" />
          </div>
          <div class="fenlei-item">
            <img class="fenlei-img" src="@/assets/image/home/Zalo.png" alt="" />
          </div>
          <div class="fenlei-item">
            <img class="fenlei-img" src="@/assets/image/home/Youtube.png" alt="" />
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="home-jie">
        <span data-aos="fade-up">{{ $t("home.title3") }} </span>
        <span data-aos="fade-up"> {{ $t("home.subtitle3") }}</span>
        <div class="home-jie-content">
          <div data-aos="fade-up" class="home-jie-content-item">
            <img src="@/assets/image/home/jie_1.png" alt="" />
            <span>{{ $t('home.mtext') }}</span>
          </div>
          <div data-aos="fade-up" class="home-jie-content-item">
            <img src="@/assets/image/home/jie_2.png" alt="" />
            <span>{{ $t('home.mtext2') }}</span>
          </div>
          <div data-aos="fade-up" class="home-jie-content-item">
            <img src="@/assets/image/home/jie_3.png" alt="" />
            <span>{{ $t('home.mtext3') }}</span>
          </div>
        </div>
        <div class="home-jie-video">
          <img src="@/assets/image/home/bg_jie.png" alt="" />
        </div>
      </div>
    </section>

    <section>
      <HomeCard
        type="1"
        :title="$t('home.mcardTl')"
        :imgUrl="require('@/assets/image/home/home_img.png')"
        :subtitle="$t('home.mcardText')"
        @click="goRouter('/products/omnichannel')"
      />
      <HomeCard
        type="2"
        :title="$t('home.mcardTl2')"
        :imgUrl="require('@/assets/image/home/home_img2.png')"
        :subtitle="$t('home.mcardText2')"
        @click="goRouter('/products/automation')"

      />
      <HomeCard
        type="1"
        :title="$t('home.mcardTl3')"
        :imgUrl="require('@/assets/image/home/home_img6.png')"
        :subtitle="$t('home.mcardText3')"
        @click="goRouter('/products/team')"

      />
      <HomeCard
        type="2"
        :title="$t('home.mcardTl4')"
        :imgUrl="require('@/assets/image/home/home_img5.png')"
        :subtitle="$t('home.mcardText4')"
        @click="goRouter('/products/crm')"

      />
      <HomeCard
        type="1"
        :title="$t('home.mcardTl5')"
        :imgUrl="require('@/assets/image/home/home_img4.png')"
        :subtitle="$t('home.mcardText5')"
        @click="goRouter('/products/analytics')"

      />
      <HomeCard
        type="2"
        :title="$t('home.mcardTl6')"
        :imgUrl="require('@/assets/image/home/home_img3.png')"
        :subtitle="$t('home.mcardText6')"
        @click="goRouter('/products/translate')"

      />
    </section>

    <section>
      <div class="w-card">
        <title-text :title="$t('plan.sectitle')" :subtitle="$t('plan.secsubtitle')"></title-text>
        <div class="wm-card">
          <mCard
            :imgUrl="require('@/assets/image/home/facebook.png')"
            :title="$t('plan.nexttitle')"
            :subtitle="$t('plan.subnext')"
            goUrl="/solution/Messenger"
          ></mCard>
          <mCard
            :imgUrl="require('@/assets/image/home/what.png')"
            :title="$t('plan.lasttitle')"
            :subtitle="$t('plan.sublast')"
            goUrl="/solution/OwnedChannel"
          ></mCard>
        </div>
      </div>
    </section>

    <section>
      <div class="user-card">
        <title-text style="padding: 40px 8%" :title="$t('plan.usertitle')" :subtitle="$t('plan.usertext')"></title-text>
        <div class="userCards-wrapper">
          <div class="userCards-track">
            <div class="userCards-container">
              <userCard
                :imgUrl="require('@/assets/image/home/user05.png')"
                userName="Mrs. W"
                :sub="$t('plan.useronesub')"
                :text="$t('plan.useronetext')"
              ></userCard>
              <userCard
                :imgUrl="require('@/assets/image/home/user01.png')"
                userName="Sarah Johnson"
                :sub="$t('plan.usertwosub')"
                :text="$t('plan.usertwotext')"
              ></userCard>
              <userCard
                :imgUrl="require('@/assets/image/home/user03.png')"
                userName="David Williams"
                :sub="$t('plan.userthreesub')"
                :text="$t('plan.userthreetext')"
              ></userCard>
              <userCard
                :imgUrl="require('@/assets/image/home/user02.png')"
                userName="Emily Smith"
                :sub="$t('plan.userfoursub')"
                :text="$t('plan.userfourtext')"
              ></userCard>
              <userCard
                :imgUrl="require('@/assets/image/home/user04.png')"
                userName="Brian K"
                :sub="$t('plan.userfivesub')"
                :text="$t('plan.userfivetext')"
              ></userCard>
            </div>
            <div class="userCards-container">
              <userCard
                :imgUrl="require('@/assets/image/home/user05.png')"
                userName="Mrs. W"
                :sub="$t('plan.usersixsub')"
                :text="$t('plan.usersixtext')"
              ></userCard>
              <userCard
                :imgUrl="require('@/assets/image/home/user01.png')"
                userName="Sarah Johnson"
                :sub="$t('plan.usersevensub')"
                :text="$t('plan.userseventext')"
              ></userCard>
              <userCard
                :imgUrl="require('@/assets/image/home/user03.png')"
                userName="David Williams"
                :sub="$t('plan.usereightsub')"
                :text="$t('plan.usereighttext')"
              ></userCard>
              <userCard
                :imgUrl="require('@/assets/image/home/user02.png')"
                userName="Emily Smith"
                :sub="$t('plan.userninesub')"
                :text="$t('plan.userninetext')"
              ></userCard>
              <userCard
                :imgUrl="require('@/assets/image/home/user04.png')"
                userName="Brian K"
                :sub="$t('plan.usertensub')"
                :text="$t('plan.usertentext')"
              ></userCard>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import HomeCard from "@/components/home-card.vue";
import titleText from "@/components/title-text.vue";
import mCard from "@/components/m-card.vue";
import userCard from "@/components/user-card.vue";
import { useRouter } from "vue-router";

const router = useRouter()
const goHref = () => {
  window.open(process.env.VUE_APP_API_LOGIN_URL, "_blank", "noopener,noreferrer");
};
const goRouter = (url) => {
  router.push(url);
};

onMounted(() => {});
</script>

<style scoped lang="scss">
.home-bg {
  position: relative;
  width: 100%;
  height: 100vh;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .bg-text {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 45%;
    left: 10%;
    transform: translate(0%, -50%);
    .home-title {
      font-size: 80px;
      line-height: 100px;
      font-weight: bold;
    }
    .home-sub-title {
      font-size: 18px;
      padding: 10px 0px 40px;
    }
    .home-btn {
      button {
        font-size: 18px;
        border-radius: 50px;
        // line-height: 56px;
        height: 56px;
        transition: all 0.3s ease;
      }
      button:hover {
        opacity: 0.8;
      }
      button:nth-child(1) {
        color: #fff;
        background: linear-gradient(270deg, #016afe 0%, #09dafd 100%);
        margin-right: 10px;
      }
      button:nth-child(2) {
        color: #026efe;
        border: 1px solid #026efe;
        background: rgba(0, 0, 0, 0);
      }
    }
  }
}
.fenlei-box {
  width: 40%;
  display: flex;
  flex-direction: column;
  padding: 40px 0 100px;
  margin: 0 auto;
  .fenlei-box-tl {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    span:nth-child(1) {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
    }
    span:nth-child(2) {
      text-align: center;
      font-size: 16px;
      color: #000e18b2;
      margin-top: 10px;
    }
  }
  .home-change {
    position: relative;
    top: 3rem;
    z-index: 1;
    margin: 0 auto;
    img {
      width: 500px;
    }
  }
  .fenlei-btn {
    position: relative;
    z-index: 2;
    margin: 0 auto;
    cursor: default;
    // width: 146px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 8px;
    border-radius: 50px;
    background: #2f4fed;
    transition: all 0.3s ease;
    img {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
    span {
      font-size: 14px;
      color: #fff;
    }
  }
  .fenlei-btn:hover {
    scale: calc(1.15);
  }
  .fenlei-line {
    margin: 0 auto;
    height: 25px;
    border-left: 1px dashed #bfcefe;
    border-right: 1px dashed #bfcefe;
  }
  .fenlei-top {
    display: flex;
    justify-content: center;
    border-top: 1px dashed #bfcefe;
    .fenlei-item {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      width: 50px;
      height: 40px;
      .fenlei-img {
        position: relative;
        z-index: 999;
        width: 24px;
        height: 24px;
        transition: all 0.1s ease;
      }
      .fenlei-img:hover {
        scale: calc(1.45);
      }
    }
    .fenlei-item::before {
      content: "";
      display: block;
      height: 16px;
      border-left: 1px dashed #bfcefe;
      border-right: 1px dashed #bfcefe;
      position: absolute;
      z-index: 999;
      top: 0;
      left: 50%;
      transform: translate(-50%, 0%);
    }
    .fenlei-item::after {
      content: "";
      display: block;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: #2f4fed;
      position: absolute;
      z-index: 999;
      top: -3px;
      left: 50%;
      transform: translate(-50%, 0%);
    }
  }
}

.home-jie {
  display: flex;
  flex-direction: column;
  font-size: 36px;
  font-weight: bold;
  color: #000;
  text-align: center;
  padding: 40px 0 100px;
  .home-jie-content {
    width: 50%;
    margin: 0 auto;
    padding: 40px 0;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    .home-jie-content-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 67px;
        height: 67px;
      }
      span {
        font-size: 20px;
        font-weight: 400;
        color: #000;
        padding: 10px 0;
        font-weight: 400;
      }
    }
  }
  .home-jie-video {
    width: 100%;
    padding: 0px 8%;
    img {
      border-radius: 10px;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
.w-card {
  padding: 40px 8% 80px;
  .wm-card {
    display: flex;
    flex-direction: row;
    gap: 8%;
  }
}

.user-card {
  padding: 40px 0px 80px;

  .userCards-wrapper {
    overflow: hidden;
    padding: 20px 0;
  }

  .userCards-track {
    display: flex;
    width: max-content;
    animation: scroll-left 30s linear infinite;
  }

  .userCards-wrapper:hover .userCards-track {
    animation-play-state: paused;
  }

  .userCards-container {
    display: flex;
    gap: 24px;
    margin-right: 24px;
  }
}

/* 滚动动画 */
@keyframes scroll-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@media (max-width: 1150px) {
  .home-bg {
    height: auto !important;
    img {
      height: auto !important;
    }
    .home-title {
      font-size: 50px !important;
      line-height: 50px !important;
    }
    .home-sub-title {
      font-size: 15px !important;
      padding: 10px 0px !important;
    }
    .home-btn {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  .home-bg {
    .bg-text {
      top: 60px !important;
      transform: none !important;
    }
    .home-title {
      font-size: 20px !important;
      line-height: 30px !important;
    }
    .home-sub-title {
      font-size: 10px !important;
      padding: 10px 0px !important;
    }
  }

  .fenlei-box {
    width: 100%;
    padding: 20px;

    .fenlei-box-tl {
      padding: 10px 0;
      span:nth-child(1) {
        font-size: 24px;
      }
      span:nth-child(2) {
        font-size: 16px;
        margin-top: 10px;
        text-align: center;
      }
    }

    .home-change {
      img {
        width: 100%;
      }
    }

    .fenlei-top {
      justify-content: center;
    }
  }

  .home-jie {
    padding: 20px 8%;
    span {
      font-size: 18px;
      color: #000;
      font-weight: 400;
    }
    .home-jie-content {
      padding: 10px 0;
      width: 100%;
      .home-jie-content-item {
        img {
          width: 50px;
          height: 50px;
        }
        span {
          font-size: 14px;
        }
      }
    }
  }

  .w-card {
    padding: 20px 8%;
    .wm-card {
      flex-direction: column;
      gap: 20px;
    }
  }

  .user-card {
    padding: 0px !important;
  }
  .userCards-wrapper {
    padding: 20px 0 60px !important;
  }
}
</style>
